export const get = (
  url = "",
  options = {},
  callback = data => {
    return data;
  }
) => {
  return new Promise((resolve, reject) => {
    Object.keys(options).forEach((key, index) => {
      url += index === 0 ? "?" : "&";

      url += `${key}=${options[key]}`;
    });

    fetch(url)
      .then(response => response.json())
      .then(response => {
        if (response.error) {
          reject(response.error);
          return;
        }

        if (response.data) {
          resolve(callback(response.data));
          return;
        }

        resolve(callback(response));
      })
      .catch(response => {
        if (response.error) {
          reject(response.error);
          return;
        }

        reject(response);
      });
  });
};

export const is_json = text => {
  try {
    JSON.parse(text);
    return true;
  } catch (e) {
    return false;
  }
};

export const are_objects_equal = (obj_a, obj_b) => {
  let obj_a_props = Object.getOwnPropertyNames(obj_a),
    obj_b_props = Object.getOwnPropertyNames(obj_b);

  if (obj_a_props.length != obj_b_props.length) {
    return false;
  }

  obj_a_props.forEach(prop => {
    if (obj_a[prop] !== obj_b[prop]) {
      return false;
    }
  });

  return true;
};

export const focusable_elements = [
  'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
];

export const copy_to_clipboard = text => {
  const fake = document.createElement("textarea");

  fake.value = text;
  fake.style.position = "fixed";
  // fake.style.visibility = 'hidden';

  document.body.appendChild(fake);
  fake.focus();
  fake.select();

  document.execCommand("copy");
  document.body.removeChild(fake);
};

export const hex_to_rbg = hex_color_code => {
  var shorthand_hex_regex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;

  hex_color_code = hex_color_code.replace(shorthand_hex_regex, function(
    m,
    r,
    g,
    b
  ) {
    return r + r + g + g + b + b;
  });

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex_color_code);

  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      }
    : null;
};

export const create_script = (url, async = false) => {
  var script = document.createElement("script");
  script.src = url;
  script.async = async;
  document.head.appendChild(script);
};

export const value_by_stringed_key = (object, string_key_path) => {
  string_key_path = string_key_path.replace(/\[(\w+)\]/g, ".$1");
  string_key_path = string_key_path.replace(/^\./, "");
  var pieces = string_key_path.split(".");

  for (let i = 0, n = pieces.length; i < n; ++i) {
    var k = pieces[i];
    if (k in object) {
      object = object[k];
    } else {
      return;
    }
  }

  return object;
};

export const update_value_by_stringed_key = (
  object,
  string_key_path,
  new_value
) => {
  string_key_path = string_key_path.replace(/\[(\w+)\]/g, ".$1");
  string_key_path = string_key_path.replace(/^\./, "");

  const pieces = string_key_path.split(".");
  let current_object_ref = object;

  for (let i = 0; i < pieces.length; i++) {
    const k = pieces[i];

    if (k in current_object_ref) {
      if (i === pieces.length - 1) {
        current_object_ref[k] = new_value;
      } else {
        current_object_ref = current_object_ref[k];
      }
    }
  }
};

export const set_default_value_on_object_prop = (obj, key, value) => {
  return new Promise(resolve => {
    const current_value = value_by_stringed_key(obj, key);
    let updated_obj = Object.assign({}, obj);

    if (["", null, undefined].includes(current_value)) {
      update_value_by_stringed_key(updated_obj, key, value);
    }

    resolve(updated_obj);
  });
};

export const sort_by = (property_name, type) => {
  return (a, b) => {
    let a_prime = value_by_stringed_key(a, property_name);
    let b_prime = value_by_stringed_key(b, property_name);

    if (type == "number") {
      a_prime = parseFloat(a_prime);
      b_prime = parseFloat(b_prime);
    }

    return a_prime < b_prime ? -1 : a_prime > b_prime ? 1 : 0;
  };
};
